// @flow

import type {Axios} from 'axios';
import type {Features} from '../../../reducers/features/types';

import axios from 'axios';
import {MerchantNotSetError, normalizeMerchantId} from '../../../utils/merchant';

type FeaturesResponse = {
  features: Features
};

export const getFeatures = (
  merchantId: number,
  axiosInstance: Axios = axios
): Promise<FeaturesResponse> => {
  const id = normalizeMerchantId(merchantId);
  if (id === null) {
    return Promise.reject(new MerchantNotSetError());
  }

  return axiosInstance.get(`/merchant/v2/merchants/${id}/features`).then(response => response.data);
};
